import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import Calendar from './Calendar';
import Home from './pages/Home';
import Landing from './pages/Landing';
import WeeklySchedule from './pages/WeeklySchedule';
import Admin from './pages/Admin';
import TwentyFourHourSchedule from './TwentyFourHourSchedule';
import ChannelsList from './pages/ChannelsList';
import ChannelScheduleAdmin from './pages/ChannelScheduleAdmin';
import WidgetLanding from './pages/WidgetLanding';
import StreamOverlay from './components/StreamOverlay';
import StreamOverlayThemed from './components/StreamOverlayThemed';
import StreamOverlayFullSummer from './components/StreamOverlayFullSummer';
import StreamOverlayNoCameraSummer from './components/StreamOverlayNoCameraSummer';
import OverlayChatStarsTest from './pages/OverlayChatStarsTest';
import TimerOverlay from './components/TimerOverlay';
import StreamTimerWidget from './components/StreamTimerWidget';
import Multistream from './pages/Multistream';
import Kanban from './pages/Kanban';
import KanbanArchivePage from './pages/KanbanArchivePage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hub" element={<Landing />} />
        <Route path="/schedule" element={<WeeklySchedule />} />
        <Route path="/calendar" element={<Navigate to="/schedule" replace />} />
        {/* Archived: the October 2025 "31 Days of Streaming" experiment */}
        <Route path="/archive/31-days" element={<Calendar />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/24hour-schedule" element={<TwentyFourHourSchedule />} />
        <Route path="/channels" element={<ChannelsList />} />
        <Route path="/schedule/:channelName" element={<TwentyFourHourSchedule />} />
        <Route path="/schedule/:channelName/admin" element={<ChannelScheduleAdmin />} />
        <Route path="/widgets" element={<WidgetLanding />} />
        <Route path="/widgets/:channelName" element={<WidgetLanding />} />
        <Route path="/widget/:channelName" element={<StreamOverlay />} />
        <Route path="/overlay/:channelName" element={<StreamOverlayThemed camera />} />
        <Route path="/overlay-no-camera/:channelName" element={<StreamOverlayThemed />} />
        <Route path="/overlay-summer/:channelName" element={<StreamOverlayFullSummer />} />
        <Route path="/overlay-summer-no-camera/:channelName" element={<StreamOverlayNoCameraSummer />} />
        <Route path="/overlay-chat-test" element={<OverlayChatStarsTest />} />
        <Route path="/timer/:channelName" element={<TimerOverlay />} />
        <Route path="/widget-timer" element={<StreamTimerWidget />} />
        <Route path="/multistream" element={<Multistream />} />
        <Route path="/kanban" element={<Kanban />} />
        <Route path="/kanban/archive" element={<KanbanArchivePage />} />
      </Routes>
    </Router>
  );
}

export default App;